import React, { useEffect, useState } from 'react';

import {
  Cancel,
  CheckCircle,
  LinkedIn,
  PhoneAndroid,
} from '@material-ui/icons';
import { IconButton } from '@material-ui/core';

const BasicInfo = ({ user, data, setData, setDisableSave, disableSave }) => {
  const [verify, setVerify] = useState(
    user?.linkedInUrl ? { linkedInUrl: 'yes' } : {}
  );
  const [profile, setProfile] = useState(
    user?.linkedInUrl ? { linkedInUrl: user?.linkedInUrl } : {}
  );

  useEffect(() => {
    if (Object.keys(verify).length > 0 && user) {
      if (Object.keys(user).length === Object.keys(verify).length) {
        setDisableSave({ ...disableSave, profile: false });
      } else {
        setDisableSave({ ...disableSave, profile: true });
      }
    }
  }, [verify]);

  useEffect(() => {
    if (Object.keys(profile).length > 0) {
      setData({ ...data, profile: profile });
    }
  }, [profile]);

  return (
    <>
      <div className=' shadow-xl rounded-lg col-span-3'>
        <div className='bg-gray-200 py-2 px-4 text-[#134F5C] text-base font-semibold'>
          Basic Info
        </div>
        {/* </div> */}
        <div className=' py-4'>
          <div className='flex flex-col space-y-4 justify-center w-full'>
            {user.about && (
              <div className='flex items-center gap-14 px-4'>
                <span className='w-3/4 flex items-center opacity-60 text-base'>
                  {user.about}
                </span>
                <span className=' w-1/4 flex items-center justify-between'>
                  <span className=' opacity-60 text-sm'>About Info</span>
                  <span>
                    <IconButton
                      onClick={() => {
                        setProfile({ ...profile, about: user.about });
                        setVerify({ ...verify, about: 'yes' });
                      }}
                      className='focus:outline-none'
                    >
                      <CheckCircle
                        htmlColor={
                          verify?.about === 'yes' ? '#76CE65' : 'inherit'
                        }
                      />
                    </IconButton>
                    <IconButton
                      onClick={() => {
                        setVerify({ ...verify, about: 'no' });
                        delete profile.about;
                        setProfile({ ...profile });
                      }}
                      className='focus:outline-none'
                    >
                      <Cancel
                        htmlColor={
                          verify?.about === 'no' ? '#CC0000' : 'inherit'
                        }
                      />
                    </IconButton>
                  </span>
                </span>
              </div>
            )}
          </div>

          <div className='flex flex-col justify-center w-full'>
            {user.phone && (
              <div className='flex items-center gap-14  px-4'>
                <span className=' flex items-center w-3/4'>
                  <PhoneAndroid />
                  <span className='ml-2 opacity-60 text-base'>
                    {user.phone}
                  </span>
                </span>
                <span className='w-1/4 flex items-center justify-between'>
                  <span className=' opacity-60 text-sm'>Contact Info</span>
                  <span>
                    <IconButton
                      onClick={() => {
                        setVerify({ ...verify, phone: 'yes' });
                        setProfile({ ...profile, phone: user.phone });
                      }}
                      className='focus:outline-none'
                    >
                      <CheckCircle
                        htmlColor={
                          verify?.phone === 'yes' ? '#76CE65' : 'inherit'
                        }
                      />
                    </IconButton>
                    <IconButton
                      onClick={() => {
                        setVerify({ ...verify, phone: 'no' });
                        delete profile.phone;
                        setProfile({ ...profile });
                      }}
                      className='focus:outline-none'
                    >
                      <Cancel
                        htmlColor={
                          verify?.phone === 'no' ? '#CC0000' : 'inherit'
                        }
                      />
                    </IconButton>
                  </span>
                </span>
              </div>
            )}
          </div>

          {/* verify button */}
          <div className='flex flex-col justify-center w-full'>
            {user.linkedInUrl && (
              <div className='flex items-center gap-2 px-4'>
                <span className='flex-grow'>
                  <span className='text-3xl text-blue-600 mr-2'>
                    <LinkedIn fontSize='inherit' htmlColor='#0077B7' />
                  </span>
                  <a
                    href={user.linkedInUrl}
                    target='_blank'
                    rel='noopener noreferrer'
                    className='text-blue-500 underline'
                  >
                    LinkedIN
                  </a>
                </span>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default BasicInfo;
